/* tslint:disable:object-literal-shorthand */
import React, { useEffect, useRef, useState } from "react";
import { useDataLoader } from "react-remote-data-hooks";
import api from "../../api";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import xrange from "highcharts/modules/xrange";
import moment from "moment";
import CheckBox from "../../components/check-box";
import { ContainerLoader } from "../../components/loader";
xrange(Highcharts);

const TenancyTimeline: React.FunctionComponent<{
  projectID?: string;
  projectName?: string;
  className?: string;
  showTitle?: boolean;
}> = (props) => {
  const chartRef = useRef<any>(null);
  const [showMasterTenancy, setShowMasterTenancy] = useState(false)

  const { data: project, loading, loaded, reload } = useDataLoader<any>((isMasterTenancy: boolean) =>
    api.project.getTenantHistory(Number(props.projectID!), isMasterTenancy)
  );

  const [options, setOptions] = useState<any>();

  useEffect(() => {
    if (!loading) {
      reload(showMasterTenancy)
    }
  }, [showMasterTenancy])

  useEffect(() => {
    const graphData = project?.graphData;

    if (graphData && Object.keys(graphData)?.length > 0) {
      const chartData: any[] = [];
      const leaeData: any[] = [];
      const tenancydrillData: any[] = [];
      const drillData: any[] = [];
      let unitkey = 0;
      let projectDrill = "";

      Object.keys(graphData)?.map((key, index) => {
        const value = graphData[key];
        value?.map((value2: any, index2: number) => {
          projectDrill = value2.projectDrill;
          let tenantStartYearUtc = "";

          if (value2.tenantStartYear) {
            tenantStartYearUtc = Date.UTC(
              value2.tenantStartYear,
              value2.tenantStartMonth,
              value2.tenantStartDay
            )?.toString();
          }
          let tenantEndYearUtc = "";

          if (value2.tenantEndYear) {
            tenantEndYearUtc = Date.UTC(
              value2.tenantEndYear,
              value2.tenantEndMonth,
              value2.tenantEndDay
            )?.toString();
          }
          let lockStartYearUtc = "";

          if (value2.lockStartYear) {
            lockStartYearUtc = Date.UTC(
              value2.lockStartYear,
              value2.lockStartMonth,
              value2.lockStartDay
            )?.toString();
          }
          let lockEndYearUtc = "";

          if (value2.lockEndYear) {
            lockEndYearUtc = Date.UTC(
              value2.lockEndYear,
              value2.lockEndMonth,
              value2.lockEndDay
            )?.toString();
          }
          if (tenantStartYearUtc || tenantEndYearUtc) {
            leaeData.push({
              x: Number(tenantStartYearUtc),
              x2: Number(tenantEndYearUtc),
              y: unitkey,
              drilldown: value2.unitName,
              tenantID: value2.tenantID,
              tenancy: value2.tenancy,
              tenantsName: value2.tenantsName,
              projectName: value2.projectName,
              unitName: value2.unitName,
              text: "Lease Period",
              partialval: value2.leasepartialfill,
              color: "#4477E0",
              partialFill: {
                amount: value2.leasepartialfill,
                fill: "#1147B7",
              },
            });
          }
          if (lockStartYearUtc || lockEndYearUtc) {
            leaeData.push({
              x: Number(lockStartYearUtc),
              x2: Number(lockEndYearUtc),
              y: unitkey,
              drilldown: value2.unitName,
              tenantID: value2.tenantID,
              tenancy: value2.tenancy,
              tenantsName: value2.tenantsName,
              projectName: value2.projectName,
              unitName: value2.unitName,
              text: "Lock-in Period",
              partialval: value2.lockpartialfill,
              color: "#Ea5c5e",
              partialFill: {
                amount: value2.lockpartialfill,
                fill: "#963F42",
              },
            });
          }

          if (typeof tenancydrillData[value2.unit] === "undefined") {
            tenancydrillData[value2.unit] = [];
          }
          tenancydrillData[value2.unit].push({
            x: tenantStartYearUtc,
            x2: tenantEndYearUtc,
            y: unitkey,
            tenantID: value2.tenantID,
            tenancy: value2.tenancy,
            tenantsName: value2.tenantsName,
            projectName: value2.projectName,
            unitName: value2.unitName,
            text: "Lease Period",
            partialval: value2.leasepartialfill,
            color: "#4477E0",
            partialFill: {
              amount: value2.leasepartialfill,
              fill: "#1147B7",
            },
          });
          /*if(typeof(lockdrillData[value2.unit]) == "undefined"){
            lockdrillData[value2.unit] = [];
            }*/
          tenancydrillData[value2.unit].push({
            x: lockStartYearUtc,
            x2: lockEndYearUtc,
            y: unitkey,
            tenantID: value2.tenantID,
            tenancy: value2.tenancy,
            tenantsName: value2.tenantsName,
            projectName: value2.projectName,
            unitName: value2.unitName,
            text: "Lock-in Period",
            partialval: value2.lockpartialfill,
            color: "#Ea5c5e",
            partialFill: {
              amount: value2.lockpartialfill,
              fill: "#963F42",
            },
          });
        });

        drillData.push({
          id: value[0].unitName,
          name: value[0].floorunitName,
          data: tenancydrillData[value[0].unitName],
        });
        unitkey = unitkey + 1;
      });

      chartData.push({
        name: props.projectName,
        drilldown: projectDrill,
        // borderColor: "black",
        pointWidth: 25,
        colorByPoint: true,
        data: leaeData,
        dataLabels: {
          enabled: true,
        },
      });

      setOptions({
        chart: {
          type: "xrange",
          borderRadius: 5,
        },
        title: {
          text: "",
        },
        xAxis: {
          type: "datetime",
        },
        yAxis: {
          title: {
            text: "",
          },
          categories: project?.yAxisData,
          reversed: true,
        },
        tooltip: {
          formatter: function (this: Highcharts.TooltipFormatterContextObject) {

            if (this.point) {
              const point = this.point as any; // Access to the data point

              // Customize tooltip content as needed
              return `<span></span>${moment(new Date(point.x)).format(
                "dddd, DD MMMM YYYY"
              )} - ${moment(new Date(point.x2)).format(
                "dddd, DD MMMM YYYY"
              )}<br><span></span><span></span>${point.projectName}:${point.unitName
                }<br><span></span>Tenant : ${point.tenancy}<br><span></span>${point.text
                } : ${Math.round(point.partialval * 100)} % completed <br/>`;
            }

            return ""; // Handle the case where point is not available
          },
        },
        series: chartData,
        drilldown: {
          series: drillData,
        },
      });
    }
  }, [project]);

  useEffect(() => {
    if (chartRef.current) {
      const containerWidth = chartRef.current.container.offsetWidth;
      chartRef.current.chart.update(
        {
          chart: {
            width: containerWidth,
          },
        },
        true,
        false,
        false
      );
    }
  }, [chartRef]);

  return <div className={props.className}>

    {props.showTitle && (
      <div className="col-12 px-0">
        <h2 className="mb-4" style={{ fontSize: "21px" }}>
          Tenancy Timeline
        </h2>
      </div>
    )}
    {<div className="">
      <span className="">
        <CheckBox
          id={`mastertenancy`}
          label="Master Tenancy"
          checked={showMasterTenancy}
          onChange={setShowMasterTenancy}
        />
      </span>
    </div>}
    {project?.graphData && Object.keys(project?.graphData)?.length > 0 ? (
      <>
        <div className="col px-0 mb-3">
          <div className="pt-2">
            <div className="container-fluid">
              <div className="mb-5 ">
                {project?.graphData &&
                  Object.keys(project?.graphData)?.length > 0 && (
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={options}
                      ref={chartRef}
                    />
                  )}
              </div>
            </div>
          </div>
        </div>
      </>
    ) : (
      !loading ?
        <div className="col-12 mb-4 mt-4 "><span>No Data Found</span></div>
      :
      <ContainerLoader
        height={window.innerHeight - 300}
      ></ContainerLoader>

    )}
  </div>
};

export default TenancyTimeline;
